module.exports = "/_next/static/images/protect-your-assets-e42e6e96fb6e44780148479fbddbbf9e.svg";